export default "__VITE_ASSET__BOmhEu5O__"